export default __webpack_public_path__ + "static/media/loader.1fc15141.gif";